import { useNavigate } from 'react-router-dom'
import { useAuth as useProviderAuth } from '@provider/context/AuthContext'
import { useAuth as usePatientAuth } from '@patient/context/AuthContext'
import localStore from '@service/local-store'
import { OPTUM_MATCH_POLICY_VERSION } from '../../constants'
import useHeaderDetails from './useHeaderDetails'
import useAdobeAnalytics from '@analytics/adobe'
import Cookies from 'universal-cookie'
// import { AUTH_TYPES } from './constants'

export const useHeaderAuth = () => {
  const navigate = useNavigate()
  const { logout: providerLogout } = useProviderAuth()
  const { logout: patientLogout } = usePatientAuth()
  const { isLoggedIn } = usePatientAuth()
  const { login, role, ipAddress, user } = useHeaderDetails()
  const { trackLink } = useAdobeAnalytics()
  const cookies = new Cookies()

  const handleLogout = (username: string) => {
    // Reset privacy policy acceptance
    localStore.set('is_OSPP_TOU_accepted', 'false')

    trackLink(
      {
        name: username,
        location: 'Header',
        type: 'internal',
      },
      {
        loginStatus: login ? 'logged in' : 'logged out',
        userType: role,
      }
    )

    // Clean up auth type storage
    cookies.remove('auth_type')
    localStore.remove('auth_type')
    providerLogout('click')
    patientLogout('click')
    navigate('/')
  }

  const handleLoginClick = (
    url: string,
    title: string,
    onDialogOpen?: () => void
  ) => {
    localStore.set('policy_details_version', OPTUM_MATCH_POLICY_VERSION)
    localStore.set('userType', 'authUser')

    trackLink(
      {
        name: title,
        location: 'Header',
        type: 'internal',
        destinationUrl: url,
      },
      {
        loginStatus: login ? 'logged in' : 'logged out',
        userType: role,
      }
    )

    if (isLoggedIn) {
      navigate(`/${role}`)
    } else {
      localStore.set('loginEvent', 'true')
      if (title === 'Patient') {
        navigate(url)
      } else if (onDialogOpen) {
        onDialogOpen()
      }
    }
  }

  const handleAuthTypeSelection = (
    authType: string,
    url: string,
    isRegister = false
  ) => {
    if (isRegister) {
      localStore.set('is_register_page', 'true')
    } else {
      localStore.set('is_register_page', 'false')
    }
    // Store auth type for successful login tracking
    cookies.set('auth_type', authType, { path: '/' })
    localStore.set('auth_type', authType)
    navigate(url)
  }

  return {
    handleLogout,
    handleLoginClick,
    handleAuthTypeSelection,
    trackLink,
    login,
    role,
    ipAddress,
    user,
  }
}
